import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, MessageCircle } from "lucide-react";
import { api, errMsg, fmtEur2, waPhone } from "@/lib/api";
import { makePdf, toB64 } from "@/lib/pdf";

export const EnviarFactura = ({ f, docRef, onDone }) => {
  const [p, setP] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/patients/${f.patient_id}`).then((r) => { const pt = r.data.patient || r.data; setP(pt); setEmail(pt.email || ""); });
  }, [f.patient_id]);
  const nombre = `Factura ${f.numero}.pdf`;
  const texto = `Hola, os enviamos la factura ${f.numero} de Salud y Visión${f.paciente ? ` de ${f.paciente}` : ""} por ${fmtEur2(f.total)}. Gracias por vuestra confianza.\n\nUn saludo,\nSalud y Visión`;
  const pdf = () => makePdf([docRef.current], nombre);
  const wa = async () => {
    setBusy(true);
    try {
      const file = await pdf();
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], text: texto, title: nombre });
      } else {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(file);
        a.download = nombre;
        a.click();
        window.open(`https://wa.me/${waPhone(p?.telefono || "")}?text=${encodeURIComponent(texto)}`, "_blank");
        toast.info("PDF descargado. En el WhatsApp pulsa el clip y adjunta el archivo descargado.", { duration: 10000 });
      }
      await api.post(`/eco/facturas/${f.id}/wa`);
      onDone();
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("No se pudo preparar el PDF");
    }
    setBusy(false);
  };
  const mail = async (modo) => {
    if (!email) return toast.error("Escribe el email de la familia");
    setBusy(true);
    try {
      const file = await pdf();
      await api.post(`/eco/facturas/${f.id}/enviar-email`, { to: email, asunto: `Factura ${f.numero} · Salud y Visión`, cuerpo: texto, pdf_base64: await toB64(file), filename: nombre, modo });
      toast.success(modo === "enviar" ? `Factura enviada a ${email}` : "Borrador guardado en el Gmail del centro");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  return (
    <div className="no-print mx-auto mb-4 max-w-3xl flex flex-wrap items-center gap-2 rounded-lg border border-slate-200 bg-white p-3" data-testid="factura-enviar">
      <span className="text-xs font-semibold uppercase tracking-wider text-slate-500 mr-1">Enviar a la familia</span>
      <button type="button" disabled={busy || !p?.telefono} onClick={wa} data-testid="factura-wa" title={p?.telefono ? "" : "La ficha no tiene teléfono"}
        className="inline-flex items-center gap-1 rounded-md bg-[#25D366] px-3 py-1.5 text-xs font-medium text-white disabled:opacity-40"><MessageCircle className="h-3.5 w-3.5" />WhatsApp</button>
      <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email de la familia" data-testid="factura-email" className="h-8 w-56 rounded border border-slate-200 px-2 text-sm" />
      <button type="button" disabled={busy} onClick={() => mail("enviar")} data-testid="factura-mail-enviar" className="inline-flex items-center gap-1 rounded-md bg-[#1E3A8A] px-3 py-1.5 text-xs font-medium text-white disabled:opacity-40"><Mail className="h-3.5 w-3.5" />Enviar por email</button>
      <button type="button" disabled={busy} onClick={() => mail("borrador")} data-testid="factura-mail-borrador" className="rounded-md border border-slate-300 px-3 py-1.5 text-xs text-slate-700 disabled:opacity-40">Guardar borrador en Gmail</button>
      <span className="text-[11px] text-slate-500 w-full" data-testid="factura-envios">
        {[f.wa_at && `WhatsApp preparado ${f.wa_at.slice(0, 10).split("-").reverse().join("/")}`, f.email_enviado_at && `Email enviado a ${f.email_a} el ${f.email_enviado_at.slice(0, 10).split("-").reverse().join("/")}`, f.email_borrador_at && !f.email_enviado_at && `Borrador en Gmail (${f.email_a})`].filter(Boolean).join(" · ")}
      </span>
    </div>
  );
};
